import * as React from 'react'
import {
  MuiRadioGroupFormik,
  MuiTextFieldFormik,
} from '@user/components/Formik'
import { ILeadOppProduct } from '@user/store/leadOppProducts/typings'
import { Field, useFormikContext } from 'formik'
import { getStyles } from './styling'
import { UseSystemNameLabel } from './UseSystemNameLabel'
import { useHandlers } from './hooks/useHandlers'
import { useEffect, useState } from 'react'
import { createSystemOpportunityName } from './functions'
import { useTheme } from '@mui/material/styles'

interface Props {
  disabled: boolean
  initialValue: string
  services: ILeadOppProduct[]
  showLabel?: boolean
  size?: string
}

const options = [
  {
    label: <UseSystemNameLabel />,
    value: 'true',
  },
  {
    label: 'Enter Custom Name',
    value: 'false',
  },
]

export function OpportunityName<T>(props: Props) {
  const {
    disabled,
    initialValue,
    services,
    showLabel = false,
    size = 'small',
  } = props

  const [customName, setCustomName] = useState<string>()
  const { errors, values, setFieldValue } = useFormikContext<T>()
  const opportunityName = values['opportunityName']
    ? values['opportunityName']
    : ''

  const useSystemName: boolean = values['useSystemName'] === 'true'
  useEffect(() => {
    if (!useSystemName) {
      setCustomName(opportunityName)

      if (opportunityName && opportunityName.trim().length > 0) {
        setFieldValue('opportunityName', opportunityName)
      }
    } else {
      setFieldValue('opportunityName', createSystemOpportunityName(services))
    }
  }, [
    setCustomName,
    useSystemName,
    opportunityName,
    initialValue,
    setFieldValue,
    services,
  ])
  const { onChange } = useHandlers<T>({ ...props, customName })
  const styles = getStyles(useTheme())
  return (
    <>
      <Field
        name="opportunityName"
        label="Opportunity Name"
        component={MuiTextFieldFormik}
        required
        fullWidth
        size={size}
        disabled={disabled || useSystemName}
        error={!!errors['opportunityName']}
        data-test-id="opportunity-name"
      />
      <Field
        name="useSystemName"
        component={MuiRadioGroupFormik}
        label={showLabel && 'Opportunity Name'}
        labelClassName={styles.label}
        onClick={onChange}
        options={options}
        disabled={false}
        radioProps={{ size: 'small' }}
        radioLabelProps={{ size: 'small' }}
        data-test-id="use-system-name"
        row
      />
    </>
  )
}
OpportunityName.displayName = 'OpportunityNameField'
